import { render, staticRenderFns } from "./EcommerceAddProductMediaWithMediaLibrary.vue?vue&type=template&id=5862c27a&scoped=true&"
import script from "./EcommerceAddProductMediaWithMediaLibrary.vue?vue&type=script&lang=js&"
export * from "./EcommerceAddProductMediaWithMediaLibrary.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceAddProductMediaWithMediaLibrary.vue?vue&type=style&index=0&id=5862c27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862c27a",
  null
  
)

export default component.exports